import { RoundImage } from '@/components/common/roundImage'
import { cn } from '@/utils/cn'
import type { FixedTermMarket } from '@/utils/internalAppSdk'
import { getTokenImage } from '@vaultsfyi/common/utils'
import type { ComponentProps } from 'react'

interface Props {
  market: FixedTermMarket
}

export const FixedTermMarketHeader = ({ market, className, ...props }: Props & ComponentProps<'header'>) => (
  <header className={cn('flex max-w-full items-center gap-2 overflow-hidden', className)} {...props}>
    <div className="flex max-w-full items-center gap-2 overflow-hidden">
      <RoundImage
        src={market.accountingAsset.assetLogo ?? getTokenImage(market.accountingAsset.symbol ?? 'fallback')}
        fallback={getTokenImage('fallback')}
        alt={market.accountingAsset.symbol ?? market.name}
        className="size-8 p-0.5"
      />
      <h1
        className="max-w-full truncate font-medium text-2xl text-heading-foreground lg:text-[28px]"
        title={market.name}
      >
        {market.name}
      </h1>
    </div>
  </header>
)
